// src/events/Events.ts
import { TypedEventBus } from './EventBus'; // Імпортуємо наш клас
import { SkillExecutedEvent } from '@/core/types/battle.types';
import { GameScene } from '@/core/types/global.types';

// --- Події Світу (World Scene) ---
export type WorldEvents = {
    CITY_SELECTED: { id: string };
    ARMY_MOVED: { from: { r: number, q: number }, to: { r: number, q: number } };
};

// --- Події Битви (Battle Scene) ---
export type BattleEvents = {
    // Краще передавати id для логіки та позицію для візуалу
    UNIT_HOVER: { id: string; position: { x: number; y: number } };
    UNIT_MOUSEMOVE: { position: { x: number; y: number } };
    UNIT_OUT: { id: string };
    UNIT_CLICK: { id: string };
    UNIT_DIE: { id: string };
    
    TOOLTIP_UPDATE: { id: string };

    HEX_HOVER: { id: string; position: { x: number; y: number } };
    HEX_MOUSEMOVE: { position: { x: number; y: number } };
    HEX_OUT: { id: string };
    HEX_CLICK: { id: string };

    MOUSE_MOVE: { x: number; y: number };

    SKILL_EXECUTED: SkillExecutedEvent;
    STAMINA_DRAIN_START: { unitId: string; amount: number };
    STAMINA_DRAIN_STOP: { unitId: string; amount: number };
    OPPORTUNITY_ATTACK: { movingUnitId: string; attackerId: string };
    FOCUS_ON_UNIT: { unitId: string; force?: boolean };
    
};

// --- Глобальні події (System) ---
export type GlobalEvents = {
    CHANGE_SCENE: { scene: GameScene };
    RESOURCES_UPDATED: { gold: number };
};

/**
 * Екземпляри автобусів
 */

// Глобальний живе завжди
export const GlobalBus = new TypedEventBus<GlobalEvents>();

// Для Битви використовуємо "let", бо ми будемо його перестворювати (destroy/new)
// Це гарантує повне очищення пам'яті при виході з бою
export let BattleBus: TypedEventBus<BattleEvents>;

// Функція для ініціалізації перед початком кожної битви
export const initBattleBus = () => {
    if (BattleBus) BattleBus.destroy(); // Про всяк випадок чистимо старий
    BattleBus = new TypedEventBus<BattleEvents>();
};